import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const PersonServiceConfig = {
  name: "Person",
  annotations: []
} as ServiceConfig;